import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Image from "../../../assets/images/platforms/shopping/image.jpg";

const Shopping = () => {

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);
  return (
    <div style={{ marginTop: "-80px" }}>
      <div className="container">
        <div className="platform-page-container">
          <div className="platform-page-inner">
            <div className="container">
              {" "}
              <img src={Image} alt="" className="p-image" />
            </div>
            <div className="">
              <p>
                You can shop online or visit any nearest PASS shopping center to
                spend up to 80% of your salary without money.{" "}
              </p>
            </div>
            <div className="signup-btn-primary">
              <NavLink to="/sign-up">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shopping;
